import { render, staticRenderFns } from "./main.organization-detail.vue?vue&type=template&id=109b1559"
import script from "./main.organization-detail.vue?vue&type=script&lang=ts"
export * from "./main.organization-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports